import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { CSSProperties } from "react"
import { Switch } from "antd"
import { classNames } from "../../../../utils/classNames"

type Props = {
    title: string | React.ReactNode
    style?: Maybe<Record<string, any>>
    containerStyle?: Maybe<React.CSSProperties>
    containerClassName?: Maybe<string>
    contentClassName?: Maybe<string>
    disabled?: boolean
    children?: React.ReactNode
    showSwitch?: boolean
    switchDisabled?: boolean
    switchValue?: boolean
    rightElement?: Maybe<React.ReactNode>
    onSwitchChange?: (val: boolean) => void
}

class DrawerBlockComponent extends React.PureComponent<Props> {
    static defaultProps = {
        showSwitch: false,
        switchValue: false,
        switchDisabled: false,
        disabled: false,
        containerStyle: {},
    }

    render() {
        return (
            <div
                className={classNames("right-pane-block-component-container", this.props.containerClassName)}
                style={this.props.containerStyle ?? {}}>
                <div
                    className="right-pane-block-component-wrapper"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}>
                    <h4 className="right-pane-block-component-title">{this.props.title}</h4>

                    {this.props.showSwitch && this.props.onSwitchChange && (
                        <Switch
                            disabled={this.props.switchDisabled}
                            onChange={val => {
                                // @ts-expect-error
                                return this.props.onSwitchChange(val)
                            }}
                            checked={this.props.switchValue}
                        />
                    )}

                    {this.props.rightElement}
                </div>

                <div
                    className={classNames("right-pane-block-component-content", this.props.contentClassName)}
                    style={{ ...this.props.style }}>
                    {this.props.disabled && <div style={styles.disabled} />}
                    {this.props.children}
                </div>

                <style jsx={true} global={true}>
                    {`
                        .right-pane-block-component-container {
                            border: 1px solid #e8e8e8;
                            margin-bottom: 1.5rem;
                            border-radius: 6px;
                        }

                        .right-pane-block-component-wrapper {
                            border-bottom: 1px solid #e8e8e8;
                            padding: 0.5rem 1rem 0.5rem 1rem;
                            margin-bottom: 0;
                            background-color: rgba(0, 0, 0, 0.02);
                        }
                        .right-pane-block-component-title {
                            color: rgba(0, 0, 0, 0.85);
                            margin-bottom: 0;
                            font-weight: 700;
                            line-height: 1.5;
                        }

                        .right-pane-block-component-title div {
                            font-weight: bold;
                        }

                        .right-pane-block-component-content {
                            padding: 2rem 1rem 2rem;
                            color: rgba(0, 0, 0, 0.75);
                            line-height: 2;
                            position: relative;
                        }
                    `}
                </style>
            </div>
        )
    }
}

const styles: Record<string, CSSProperties> = {
    disabled: {
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundColor: "#FFF",
        zIndex: "4",
        opacity: "0.6",
        top: 0,
        left: 0,
    },
}
export default DrawerBlockComponent
